export default "__VITE_PUBLIC_ASSET__cb42d05f__"